import {animate, keyframes, style, transition, trigger} from '@angular/animations';

export const AlertError = [
    trigger(
        'alertError', [
            transition('* => true', [
                animate('500ms', keyframes([
                    style({
                        color: 'red',
                        transform: 'translateX(0)',
                        'transform-origin': '50% 50%'
                    }),
                    style({
                        transform: 'translateX(-30px) rotate(6deg)'
                    }),
                    style({
                        transform: 'translateX(15px) rotate(-6deg)'
                    }),
                    style({
                        transform: 'translateX(-15px) rotate(3.6deg)'
                    }),
                    style({
                        transform: 'translateX(9px) rotate(-2.4deg)'
                    }),
                    style({
                        transform: 'transform: translateX(-6px) rotate(1.2deg)'
                    }),
                    style({
                        transform: 'translateX(0)',
                        'transform-origin': '50% 50%'
                    }),
                ]))
            ]),
            transition('* => false', [
                animate('1000ms', style({color: '#d7d7d7'}))
            ])
        ]
    )
];

export const opacityChanged = [
    trigger('opacityChanged', [
        transition(':leave', animate('.2s ease-in', keyframes([
            style({
                opacity: 1,
            }),
            style({
                opacity: .5,
            }),
            style({
                opacity: 0,
                display: 'none'
            })
        ]))),
        transition(':enter', animate('.2s ease-in', keyframes([
            style({
                opacity: 0,
            }),
            style({
                opacity: .5,
            }),
            style({
                opacity: 1,
                display: 'block',
            })
        ])))
    ])
];
